import React, { useMemo } from "react";

// A persistent, low-visibility field of bubbles spread evenly across the
// window, each wandering randomly around its spot. Purely decorative
// background; colours/layering are handled in CSS (see .page-bubble). It sits
// behind all cards, text and images.
function PageBubbles() {
  const bubbles = useMemo(() => {
    const cols = 12;
    const rows = 8;
    const cellW = 100 / cols;
    const cellH = 100 / rows;
    const wander = () => (Math.random() - 0.5) * 44; // px offset around the spot
    const arr = [];
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < cols; c++) {
        const duration = 12 + Math.random() * 12;
        arr.push({
          id: `${r}-${c}`,
          // Even grid position with a little jitter so it doesn't look rigid.
          left: (c + 0.5) * cellW + (Math.random() - 0.5) * cellW * 0.7,
          top: (r + 0.5) * cellH + (Math.random() - 0.5) * cellH * 0.7,
          size: 6 + Math.random() * 20,
          duration,
          // Negative delay => each bubble starts partway through its cycle, so
          // they're already desynchronised at load (no uniform pop-in).
          delay: -Math.random() * duration,
          dx1: wander(),
          dy1: wander(),
          dx2: wander(),
          dy2: wander(),
          dx3: wander(),
          dy3: wander(),
          opacity: 0.015 + Math.random() * 0.03
        });
      }
    }
    return arr;
  }, []);

  return (
    <div className="page-bubbles" aria-hidden="true">
      {bubbles.map((b) => (
        <span
          key={b.id}
          className="page-bubble"
          style={{
            left: `${b.left}%`,
            top: `${b.top}%`,
            width: `${b.size}px`,
            height: `${b.size}px`,
            animationDuration: `${b.duration}s`,
            animationDelay: `${b.delay}s`,
            "--dx1": `${b.dx1}px`,
            "--dy1": `${b.dy1}px`,
            "--dx2": `${b.dx2}px`,
            "--dy2": `${b.dy2}px`,
            "--dx3": `${b.dx3}px`,
            "--dy3": `${b.dy3}px`,
            "--bubble-opacity": b.opacity
          }}
        />
      ))}
    </div>
  );
}

export default PageBubbles;
